module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_wayo-1c4c17c98bbbf8fe3cba6a8093634e64.jpg";